import { observer, inject } from 'mobx-react';
import React from 'react';
import MainSectionLayout from '../layout/MainSectionLayout';
import { Instance, isActionContextThisOrChildOf } from 'mobx-state-tree';
import { Page, TLCode } from '../../common/enums';
import {
  LocaleStore,
  ApplicationStore,
  SystemStatusStore,
  PlannerStore,
  DutyOffRequestStore,
  AuthenticationStore,
  SecretariatStore,
  PharmacyAnnualReviewStore,
  PushNotificationStore,
  UiStore,
} from '../../store';
import { Card, Checkbox } from 'antd';
import {
  Button,
  ButtonGroup,
  Collapse,
  InputGroup,
  Label,
  FileInput,
  Radio,
  RadioGroup,
  NumericInput,
} from '@blueprintjs/core';
import Select from 'react-select';
import { DateInput } from '@blueprintjs/datetime';
import { Spinner } from '@blueprintjs/core';
import * as glamor from 'glamor';
import { TranslatedMessage } from '../common/translation';
import styled from '@emotion/styled';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import SecretariatSelection from '../common/dropdownSelection/SecretariatSelection';
import { css } from 'emotion';
import { Secretariat } from '../../store/models/Secretariat';
import NotificationToast from '../common/NotificationToast';
import { ModalStore } from '../../store/ModalStore';
import PlannerFileLoadingModal from './PlannerFileLoadingModal';
import { SystemStatusSubSystem } from '../../common/enums/SystemStatusSubSystem';
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Legend,
  Tooltip as ChartTooltip,
  Label as ChartLabel,
  ResponsiveContainer,
} from 'recharts';
import { getSemester, getFirstMonday, getFirstSunday } from '../../common/utils';
import { formatNumber } from '../../common/formatUtils';
import SimpleTextFormContent from '../common/form/SimpleTextFormGroup';
import moment from 'moment';
import { forEach } from 'lodash';

interface PlannerPageProps extends WithTranslateProps {
  LocaleStore?: Instance<typeof LocaleStore>;
  ApplicationStore?: Instance<typeof ApplicationStore>;
  SystemStatusStore?: Instance<typeof SystemStatusStore>;
  PlannerStore?: Instance<typeof PlannerStore>;
  DutyOffRequestStore?: Instance<typeof DutyOffRequestStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  PharmacyAnnualReviewStore?: Instance<typeof PharmacyAnnualReviewStore>;
  ModalStore?: Instance<typeof ModalStore>;
  PushNotificationStore?: Instance<typeof PushNotificationStore>;
  UiStore?: Instance<typeof UiStore>;
}

interface PlannerPageState {
  isLoading: boolean;
  isOpen: boolean;
  secretariatId?: number;
  annualReviewIssLoading: boolean;
  scoreRequestTime: string;
  matchRequestTime: string;
  indictmentRequestTime: string;
  prevScoreRequestTime: string;
  prevMatchRequestTime: string;
  prevIndictmentRequestTime: string;
  dutyAssignmentSaveRequestTime: string;
  firstDate: string;
  lastDate: string;
  startDate: string;
  levelMode: string;
  solvingStart: any;
  fileIsLoading: boolean;
  modalFileLoadingOpened: boolean;
  dutiesImportError: string[];
  loginState: any;
  hangfireState: any;
  notification: string;
  checkStartYear: string;
  restartDate: any;
  prevRunning: boolean;
  prevTerminatedEarly: boolean;
  score?: any;
  prevScore?: any;
  matchList: string[];
  prevMatchList: string[];
  ruleList: string[];
  ruleSet: Map<string, number>;
  ruleScores: Map<string, string>;
  //ruleCounts: number[];
  prevRuleCounts: Map<string, number>;
  prevRuleScores: Map<string, string>;
  indictmentList: string[];
  explanationList: string[];
  scoreList: number[];
  scoreList1: [];
  scoreListH1: [];
  scoreListM1: [];
  scoreListS1: [];
  scoreList2: [];
  scoreListH2: [];
  scoreListM2: [];
  scoreListS2: [];
  runId1: string;
  runId2: string;
  prevIndictmentList: string[];
  ruleFileName?: string;
  kryoFileName?: string;
  apbNumberToImport?: string;
  googleMapsMaxCalls?: number;
  saving?: boolean;
  clearDutyAssignments?: boolean;
  stopAfterOneSolution?: boolean;
  calcUphoc?: boolean;
  calcCerpan?: boolean;
  calcUrpc?: boolean;
  calcApnl?: boolean;
  calcAppl?: boolean;
  calcOthers?: boolean;
  calcGroups: string;
  calcSecretariats: string[];
  runName?: string;
  runDescription?: string;
  semester?: string;
  database?: string;
  typeToCopy: string;
  semesterToCopy: string;
  yearToCopyFrom: string;
  yearToCopyTo: string;
  semesterYear: number;
  prevCalcDuration?: any;
  prevSolCount?: any;
  calcDuration?: any;
  solCount?: any;
  chDuration: number;
  planningIdToPromote: string;
}

@inject('AuthenticationStore')
@inject('LocaleStore')
@inject('ApplicationStore')
@inject('DutyOffRequestStore')
@inject('SystemStatusStore')
@inject('PlannerStore')
@inject('SecretariatStore')
@inject('PharmacyAnnualReviewStore')
@inject('ModalStore')
@inject('PushNotificationStore')
@inject('UiStore')
@observer
class PlannerPage extends React.Component<PlannerPageProps, PlannerPageState> {
  state = {
    isLoading: false,
    isOpen: true,
    center: {
      lat: 50.05,
      lng: 4.49,
    },
    zoom: 5,
    google: {
      apiKey: 'AIzaSyAHKfZ1yH7pudlmQ4441Plv9Aiic1tunQc',
    },
    annualReviewIssLoading: false,
    scoreRequestTime: '',
    matchRequestTime: '',
    indictmentRequestTime: '',
    prevScoreRequestTime: '',
    prevMatchRequestTime: '',
    prevIndictmentRequestTime: '',
    dutyAssignmentSaveRequestTime: '',
    firstDate: '2020-07-01',
    startDate: '2021-01-02',
    lastDate: '2021-07-04',
    levelMode: 'RealLevels',
    solvingStart: new Date(),
    fileIsLoading: false,
    modalFileLoadingOpened: false,
    dutiesImportError: [],
    loginState: '',
    hangfireState: '',
    notification: '',
    checkStartYear: '',
    restartDate: new Date(),
    prevRunning: false,
    prevTerminatedEarly: false,
    matchList: [],
    prevMatchList: [],
    ruleList: [],
    ruleSet: new Map<string, number>(),
    ruleScores: new Map<string, string>(),
    prevRuleCounts: new Map<string, number>(),
    prevRuleScores: new Map<string, string>(),
    indictmentList: [],
    explanationList: [],
    scoreList: [],
    scoreList1: [],
    scoreListH1: [],
    scoreListM1: [],
    scoreListS1: [],
    scoreList2: [],
    scoreListH2: [],
    scoreListM2: [],
    scoreListS2: [],
    runId1: '',
    runId2: '',
    prevIndictmentList: [],
    clearDutyAssignments: true,
    stopAfterOneSolution: false,
    calcUphoc: true,
    calcCerpan: true,
    calcUrpc: true,
    calcApnl: true,
    calcAppl: true,
    calcOthers: true,
    calcGroups: '',
    calcSecretariats: [],
    runName: 'RUN-',
    runDescription: '',
    semester: '',
    database: '',
    typeToCopy: 'bp',
    semesterToCopy: '',
    yearToCopyFrom: '',
    yearToCopyTo: '',
    semesterYear: new Date().getFullYear(),
    prevCalcDuration: 0,
    prevSolCount: 0,
    calcDuration: 0,
    solCount: 0,
    chDuration: 2,
    planningIdToPromote: '-1',
  } as PlannerPageState;

  _isMounted = false;

  async componentDidMount() {
    this._isMounted = true;

    const plannerFormFromSession = JSON.parse(sessionStorage.getItem('plannerFormState') || '{}');

    if (plannerFormFromSession) {
      this._isMounted && this.setState({ ...plannerFormFromSession });
    }
    else {
      const semester = getSemester(new Date());
      this._isMounted &&
        this.setState({
          lastDate: semester.endStr,
          startDate: semester.beginningStr,
          firstDate: semester.beginningStr,
          runName: 'RUN-' + semester.name,
          semester: 'S1',
        });
    }
    this._isMounted && this.setState({ isLoading: true });
    const { AuthenticationStore, ApplicationStore, SecretariatStore, translate } = this.props;
    if (AuthenticationStore!.isSecretariat) {
      if (AuthenticationStore!.secretariatId === null) {
        ApplicationStore!.navigate(`${Page.Error}/${translate(TLCode.ERROR_NoSecretariatRelatedToThisUser)}`);
      } else {
        this._isMounted && this.setState({ secretariatId: AuthenticationStore!.secretariatId });
      }
    } else {
      await SecretariatStore!.checkListLoaded(); // loadList();
    }
    this.getLoginState();
    this.getHangfireState();
    this.getDatabase();
    this._isMounted && this.setState({ isLoading: false });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    const watchedStates = [
      'semesterYear',
      'firstDate',
      'startDate',
      'lastDate',
      'runDescription',
      'runName',
      'calcGroups',
      'clearDutyAssignments',
      'stopAfterOneSOlution',
      'calcUphoc',
      'calcCerpan',
      'calcUrpc',
      'calcApnl',
      'calcAppl'
    ];

    const hasStateChanged = watchedStates.some(
      state => this.state[state] !== prevState[state]
    );

    if (hasStateChanged) {
      this.savePlannerStateInSession();
    }
  }

  savePlannerStateInSession = () => {
    var plannerForm = {
      semesterYear: this.state.semesterYear,
      firstDate: this.state.firstDate,
      startDate: this.state.startDate,
      lastDate: this.state.lastDate,
      runDescription: this.state.runDescription,
      runName: this.state.runName,
      calcGroups: this.state.calcGroups,
      clearDutyAssignments: this.state.clearDutyAssignments,
      calcUphoc: this.state.calcUphoc,
      calcCerpan: this.state.calcCerpan,
      calcUrpc: this.state.calcUrpc,
      calcApnl: this.state.calcApnl,
      calcAppl: this.state.calcAppl,
    }

    sessionStorage.setItem('plannerFormState', JSON.stringify(plannerForm));
  }

  setFirstDate = (date) => {
    this.setState({ firstDate: moment(date).format('YYYY-MM-DD') });
    this.props.UiStore!.setDiagnosticPageFirstDate(date);
  };

  setStartDate = (date) => {
    this.setState({ startDate: moment(date).format('YYYY-MM-DD') });
    this.props.UiStore!.setDiagnosticPageStartDate(date);
  };

  setEndDate = (date) => {
    // if (this.state.isMounted) {
    this.setState({ lastDate: moment(date).format('YYYY-MM-DD') });
    this.props.UiStore!.setDiagnosticPageEndDate(date);
    // }
  };

  onSecretariatSelected = async (value: Instance<typeof Secretariat>) => {
    this._isMounted && this.setState({ secretariatId: value.secretariatId });
  };

  assessPlanning = async(data) => {
    this._isMounted && this.setState({ stopAfterOneSolution: true });
    // start/stop
    await this.startPlanner(data);
    // getMatches
    await this.getConstraintMatchTotal(data);
  };

  startPlanner = async (data) => {
    this._isMounted && this.setState({ solvingStart: new Date() });
    let secretariatList: string[] = [];
    if (this.state.calcUphoc) secretariatList.push('UPHOC');
    if (this.state.calcCerpan) secretariatList.push('CERPAN');
    if (this.state.calcUrpc) secretariatList.push('URPC');
    if (this.state.calcApnl) secretariatList.push('APNL');
    if (this.state.calcAppl) secretariatList.push('APPL');
    if (secretariatList.length == 0) secretariatList.push('all');
    const calcSecretariats = secretariatList.join(',');

    await this.props.PlannerStore!.startPlanner({
      firstDate: this.state.firstDate!,
      lastDate: this.state.lastDate!,
      startDate: this.state.startDate,
      mode: this.state.levelMode!,
      configFile: this.state.ruleFileName!,
      clearDutyAssignments: this.state.clearDutyAssignments!,
      stopAfterOneSolution: this.state.stopAfterOneSolution!,
      calcUphoc: this.state.calcUphoc!,
      calcUrpc: this.state.calcUrpc!,
      calcOthers: this.state.calcOthers!,
      calcGroups: this.state.calcGroups,
      calcSecretariats: calcSecretariats,
      runName: this.state.runName!,
      runDescription: this.state.runDescription!,
      chDuration: this.state.chDuration!,
    });
  };

  takeSnapshot = async (data) => {
    this._isMounted && this.setState({ solvingStart: new Date() });
    await this.props.PlannerStore!.takeSnapshot({
      lastDate: this.state.lastDate!,
      firstDate: this.state.startDate,
    });
  };

  downloadDutyAssignments = async (data) => {
    await this.props.PlannerStore!.downloadPlanning({
      from: this.state.startDate,
      to: this.state.lastDate,
    });
  };

  replicateLevel1DutyAssignments = async () => {
    await this.props.PlannerStore!.replicateLevel1DutyAssignments({
      startDate: this.state.startDate,
      lastDate: this.state.lastDate!,
    });
  };

  suspendPlanner = async (data) => {
    await this.props.PlannerStore!.suspendPlanner({});
  };
  resumePlanner = async (data) => {
    await this.props.PlannerStore!.resumePlanner({});
  };
  stopPlanner = async (data) => {
    await this.props.PlannerStore!.stopPlanner({});
  };
  getPlannerStatus = async (data) => {
    await this.props.PlannerStore!.getStatus({});
    this._isMounted && this.setState({ scoreRequestTime: new Date().toLocaleString() });
  };

  checkDutyOffRequests = async () => {
    this._isMounted && this.setState({ isLoading: true });
    await this.props.DutyOffRequestStore!.checkDutyOffRequests(this.state.checkStartYear);
    this._isMounted && this.setState({ isLoading: false });
  };
  // getScore = async (data) => {
  //   await this.props.PlannerStore!.getScore({});
  // };
  // explainScore = async (data) => {
  //   await this.props.PlannerStore!.explainScore({});
  // };

  getScoreExplanation = async (data) => {
    await this.props.PlannerStore!.getScoreExplanation({});
    const plannerStatus = this.props.PlannerStore!.dataList;
    this._isMounted && this.setState({ explanationList: plannerStatus[0] ? plannerStatus[0].indictmentList : ['n/a'] });
  };

  getConstraintMatchTotal = async (data) => {
    this._isMounted && this.setState({ prevScoreRequestTime: this.state.scoreRequestTime });
    this._isMounted && this.setState({ prevMatchRequestTime: this.state.matchRequestTime });
    this._isMounted && this.setState({ prevScore: this.state.score ? { ...this.state.score } : null });
    this._isMounted && this.setState({ prevCalcDuration: this.state.calcDuration ? this.state.calcDuration : 0 });
    this._isMounted && this.setState({ prevSolCount: this.state.solCount ? this.state.solCount : 0 });
    this._isMounted && this.setState({ prevMatchList: [...this.state.matchList] });
    this._isMounted && this.setState({ matchList: [] });

    await this.props.PlannerStore!.getStatus({});
    await this.props.PlannerStore!.getConstraintMatchTotal({});
    // await this.props.PlannerStore!.getScores({});

    // await this.props.PlannerStore!.getScores(0);
    const date = new Date().toLocaleString();
    const plannerStatus = this.props.PlannerStore!.dataList;
    this._isMounted && this.setState({ matchList: plannerStatus[0] ? plannerStatus[0].matchList : ['n/a'] });
    this._isMounted && this.setState({ scoreList: plannerStatus[0] ? plannerStatus[0].scoreList : [0] });
    this._isMounted && this.setState({ scoreRequestTime: date });
    this._isMounted && this.setState({ matchRequestTime: date });
    const score = plannerStatus[0]
      ? plannerStatus[0].status
        ? plannerStatus[0].status.currentBestScore
        : { hardScore: 'n/a', softScore: 'n/a', mediumScore: 'n/a' }
      : { hardScore: 'n/a', softScore: 'n/a', mediumScore: 'n/a' };
    this._isMounted && this.setState({ score: score });

    const calcDuration = plannerStatus[0]
      ? plannerStatus[0].status
        ? plannerStatus[0].status.duration
        : 'n/a'
      : 'n/a';
    this._isMounted && this.setState({ calcDuration: calcDuration });
    const solutionCount = plannerStatus[0]
      ? plannerStatus[0].status
        ? plannerStatus[0].status.solutionCount
        : 'n/a'
      : 'n/a';
    this._isMounted && this.setState({ solCount: solutionCount });
    if (plannerStatus[0]) {
      this.updateRuleList(plannerStatus[0].matchList);
    }
  };

  updateRuleList = (matchList: string[]) => {
    this.setState({ prevRuleCounts: this.state.ruleSet });
    this.setState({ prevRuleScores: this.state.ruleScores });
    let tempSet = new Map(this.state.ruleSet);
    tempSet.forEach((value, key, map) => map.set(key, 0));
    let tempScores = new Map(this.state.ruleScores);
    tempScores.forEach((value, key, map) => map.set(key, ''));
    matchList.forEach((match) => {
      const ruleItems = match.split('## ');
      const ruleCount = +ruleItems[1];
      if (!Number.isNaN(ruleCount)) {
      //const [first, rest] = ruleItems[0].split('hard/');
      //const padded = first.padStart(11, " ").replace(/ /g, "\u00A0");
      const ruleScore = ruleItems[0];
      //const ruleScore = `${padded}hard/${rest}`; //scoreItems[0].padStart(11, '_') + "hard"+scoreItems[1]; //ruleItems[0];
      const ruleName = ruleItems[2];
      tempSet.set(ruleName, ruleCount);
      tempScores.set(ruleName, ruleScore);
      }
    });
    this._isMounted && this.setState({ ruleSet: tempSet });
    this._isMounted && this.setState({ ruleScores: tempScores });
  };

  getIndictmentMap = async (data) => {
    // await this.props.PlannerStore!.getScore({});

    this._isMounted && this.setState({ prevScoreRequestTime: this.state.scoreRequestTime });
    this._isMounted && this.setState({ prevMatchRequestTime: this.state.matchRequestTime });
    this._isMounted && this.setState({ prevIndictmentRequestTime: this.state.indictmentRequestTime });
    this._isMounted && this.setState({ prevScore: this.state.score ? { ...this.state.score } : null });
    this._isMounted && this.setState({ prevMatchList: [...this.state.matchList] });
    this._isMounted && this.setState({ prevIndictmentList: [...this.state.indictmentList] });
    await this.props.PlannerStore!.getStatus({});
    await this.props.PlannerStore!.getConstraintMatchTotal({});
    await this.props.PlannerStore!.getIndictmentMap({});
    //await this.props.PlannerStore!.getScoreExplanation({});
    const date = new Date().toLocaleString();
    const plannerStatus = this.props.PlannerStore!.dataList;
    this._isMounted && this.setState({ matchList: plannerStatus[0] ? plannerStatus[0].matchList : ['n/a'] });
    this._isMounted && this.setState({ indictmentList: plannerStatus[0] ? plannerStatus[0].indictmentList : ['n/a'] });
    this._isMounted && this.setState({ scoreRequestTime: date });
    this._isMounted && this.setState({ matchRequestTime: date });
    this._isMounted && this.setState({ indictmentRequestTime: date });
    const score = plannerStatus[0]
      ? plannerStatus[0].status
        ? plannerStatus[0].status.currentBestScore
        : { hardScore: 'n/a', softScore: 'n/a', mediumScore: 'n/a' }
      : { hardScore: 'n/a', softScore: 'n/a', mediumScore: 'n/a' };
    this._isMounted && this.setState({ score: score });
  };

  // saveDutyAssignments = async (data) => {
  //   this.props.PushNotificationStore!.planningSaveStart();
  //   const confirm = await this.props.ModalStore!.confirm.show(
  //     this.props.translate(TLCode.ROSTER_SaveConfirmationTitle),
  //     this.props.translate(TLCode.ROSTER_SaveConfirmationText),
  //   );
  //   if (confirm) {
  //     this.setState({ saving : true });
  //     await this.props.PlannerStore!.saveDutyAssignments({});
  //     this._isMounted && this.setState({ dutyAssignmentSaveRequestTime: new Date().toLocaleString() });
  //     this.setState({ saving : false });
  //   }
  // };
  // publishPlanning = async () => {
  //   // this.props.PushNotificationStore!.planningPublishStart();
  //   const confirm = await this.props.ModalStore!.confirm.show(
  //     this.props.translate(TLCode.ROSTER_PublishConfirmationTitle),
  //     this.props.translate(TLCode.ROSTER_PublishConfirmationText),
  //   );
  //   if (confirm) {
  //     this.state.saving = true;
  //     await this.props.PlannerStore!.publishPlanning({
  //       firstDate: this.state.startDate,
  //       lastDate: this.state.lastDate,
  //     });
  //     // this._isMounted && this.setState({ dutyAssignmentSaveRequestTime: new Date().toLocaleString() });
  //     this.state.saving = false;
  //   }
  // };

  savePlanning = async () => {
    //this.props.PushNotificationStore!.planningPromoteStart();
    // const confirm = await this.props.ModalStore!.confirm.show(
    //   this.props.translate(TLCode.ROSTER_PromoteConfirmationTitle),
    //   this.props.translate(TLCode.ROSTER_PromoteConfirmationText),
    // );
    // if (confirm) {
    this.setState({ saving: true });
    await this.props.PlannerStore!.savePlanning({});
    this.setState({ saving: false });
    // }
  };

  promotePlanning = async () => {
    //this.props.PushNotificationStore!.planningPromoteStart();
    const confirm = await this.props.ModalStore!.confirm.show(
      this.props.translate(TLCode.ROSTER_PromoteConfirmationTitle),
      this.props.translate(TLCode.ROSTER_PromoteConfirmationText),
    );
    if (confirm) {
      this.setState({ saving: true });
      await this.props.PlannerStore!.promotePlanning(
        this.state.planningIdToPromote,
        this.state.calcGroups === '' ? 'all' : this.state.calcGroups,
      );
      //this._isMounted && this.setState({ promoteRequestTime: new Date().toLocaleString() });
      this.setState({ saving: false });
    }
  };

  savePlanningData = async (data) => {
    const confirm = await this.props.ModalStore!.confirm.show(
      this.props.translate(TLCode.ROSTER_SaveConfirmationTitle),
      this.props.translate(TLCode.ROSTER_SaveConfirmationText),
    );
    if (confirm) {
      await this.props.PlannerStore!.fullSaveSolution({});
    }
  };

  serializeSolution = (data) => {
        this._isMounted && this.setState({ solvingStart: new Date() });
    let secretariatList: string[] = [];
    if (this.state.calcUphoc) secretariatList.push('UPHOC');
    if (this.state.calcCerpan) secretariatList.push('CERPAN');
    if (this.state.calcUrpc) secretariatList.push('URPC');
    if (this.state.calcApnl) secretariatList.push('APNL');
    if (this.state.calcAppl) secretariatList.push('APPL');
    if (secretariatList.length == 0) secretariatList.push('all');
    const calcSecretariats = secretariatList.join(',');

    // await this.props.PlannerStore!.startPlanner({
    //   firstDate: this.state.firstDate!,
    //   lastDate: this.state.lastDate!,
    //   startDate: this.state.startDate,
    //   mode: this.state.levelMode!,
    //   configFile: this.state.ruleFileName!,
    //   clearDutyAssignments: this.state.clearDutyAssignments!,
    //   calcUphoc: this.state.calcUphoc!,
    //   calcUrpc: this.state.calcUrpc!,
    //   calcOthers: this.state.calcOthers!,
    //   calcGroups: this.state.calcGroups,
    //   calcSecretariats: calcSecretariats,
    //   runName: this.state.runName!,
    //   runDescription: this.state.runDescription!,
    //   chDuration: this.state.chDuration!,
    // });

    this.props.PlannerStore!.serializeSolution({
      firstDate: this.state.firstDate!,
      lastDate: this.state.lastDate!,
      startDate: this.state.startDate,
      mode: this.state.levelMode!,
      configFile: this.state.ruleFileName!,
      clearDutyAssignments: this.state.clearDutyAssignments!,
      stopAfterOneSolution: this.state.stopAfterOneSolution!,
      calcUphoc: this.state.calcUphoc!,
      calcUrpc: this.state.calcUrpc!,
      calcOthers: this.state.calcOthers!,
      calcGroups: this.state.calcGroups,
      calcSecretariats: calcSecretariats,
      runName: this.state.runName!,
      runDescription: this.state.runDescription!,
      chDuration: this.state.chDuration!,
    });

    //this.props.PlannerStore!.serializeSolution({});
  };

  reloadSolution = async (data) => {
    const confirm = await this.props.ModalStore!.confirm.show(
      this.props.translate(TLCode.ROSTER_DeserializeConfirmationTitle),
      this.props.translate(TLCode.ROSTER_DeserializeConfirmationText),
    );
    if (confirm) {
      this.props.PlannerStore!.reloadSolution({ filename: this.state.kryoFileName });
    }
  };

  checkMissingBlackPoints = () => { };

  closeBlackPointEncoding = () => { };

  calculateAnnualReviews = async () => {
    if (this.state.secretariatId == null) {
      NotificationToast.showError(this.props.translate(TLCode.MULTI_CALENDAR_NoSecretariatSelected));
    } else {
      this._isMounted && this.setState({ annualReviewIssLoading: true });
      await this.props.PharmacyAnnualReviewStore!.generateAnnualReview(this.state.secretariatId!, 2020);
      this._isMounted && this.setState({ annualReviewIssLoading: false });
    }
  };

  handleFileTextChange = (e) => {
    this.setState({ ruleFileName: e.target.value });
  };

  handleKryoFileTextChange = (e) => {
    this.setState({ kryoFileName: e.target.value });
  };

  uploadPharmacies = () => { };

  initializeHangfire = async () => {
    await this.props.PlannerStore!.initializeHangfire();
  };

  downloadAdjacentPharmacyData = async () => {
    await this.props.PlannerStore!.downloadAdjacentPharmacyData();
  };

  calculateNeighborhoods = () => { };

  openPlannerPanel = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  cleanupBuffer = (buffer) => {
    console.log(buffer.length);
    return buffer.substring(39, 100).replace(/\//g, '-');
  };

  criteria: any = {
    subSystem: SystemStatusSubSystem.ACCESS,
  };

  hangfireCriteria: any = {
    subSystem: SystemStatusSubSystem.HANGFIRE,
  };

  authorizeLogin = async () => {
    await this.props.SystemStatusStore!.authorizeLogin();
    const loginState = await this.props.SystemStatusStore!.search(this.criteria);
    this._isMounted && this.setState({ loginState });
  };

  limitLogin = async () => {
    await this.props.SystemStatusStore!.limitLogin(this.state.restartDate);
    const loginState = await this.props.SystemStatusStore!.search(this.criteria);
    this._isMounted && this.setState({ loginState });
  };

  minimalLogin = async () => {
    await this.props.SystemStatusStore!.minimalLogin();
    const loginState = await this.props.SystemStatusStore!.search(this.criteria);
    this._isMounted && this.setState({ loginState });
  };

  pushNotification = () => {
    this.props.PushNotificationStore!.push(this.state.notification);
  };

  importPharmacy = () => {
    this.props.PlannerStore!.importPharmacy(this.state.apbNumberToImport);
  };

  saveGoogleMapsMaxCalls = () => {
    // this.props.ApplicationStore!.
  };

  startHangfire = async () => {
    await this.props.SystemStatusStore!.startHangfire();
    // const hangfireState = await this.props.SystemStatusStore!.search(this.hangfireCriteria);
    // this.setState({ hangfireState });
    this.getHangfireState();
  };

  stopHangfire = async () => {
    await this.props.SystemStatusStore!.stopHangfire();
    // const hangfireState = await this.props.SystemStatusStore!.search(this.hangfireCriteria);
    // this.setState({ hangfireState });
    this.getHangfireState();
  };

  getLoginState = async () => {
    const loginState = await this.props.SystemStatusStore!.search(this.criteria);
    this._isMounted && this.setState({ loginState });
  };

  getHangfireState = async () => {
    const hangfireState = await this.props.SystemStatusStore!.search(this.hangfireCriteria);
    this._isMounted && this.setState({ hangfireState });
  };

  getDatabase = async () => {
    await this.props.ApplicationStore!.getDatabase();
  };

  onNotificationChange = (data) => {
    this.setState({ notification: data });
  };

  onApbNumberChange = (data) => {
    this.setState({ apbNumberToImport: data });
  };

  onGoogleMapsMaxCallsChange = (data) => {
    this.setState({ googleMapsMaxCalls: data });
  };

  // setS1 = () => {
  //   const currentSemester = getSemester(new Date());
  //   let date;
  //   if (currentSemester.current === 'S1') {
  //     date = new Date();
  //     date.setDate(1);
  //     date.setMonth(8);
  //     date.setYear(date.getFullYear() - 1);
  //   } else {
  //     date = new Date();
  //     date.setDate(1);
  //     date.setMonth(3);
  //   }
  //   const semester = getSemester(new Date(date));
  //   this.setState({ lastDate: semester.endStr, startDate: semester.beginningStr, firstDate: semester.beginningStr.substr(0,5)+ "01-01", runName: 'RUN-'+semester.name })
  // };

  handleSemesterYearValueChange = (_valueAsNumber: number, _valueAsString: string) => {
    this.setState({ semesterYear: _valueAsNumber });
    this.props.UiStore!.setDiagnosticPageCurrentSemesterYear(_valueAsNumber);
  };

  handleCHDurationValueChange = (_valueAsNumber: number, _valueAsString: string) => {
    this.setState({ chDuration: _valueAsNumber });
  };

  setS1 = () => {
    // this.handlePlanningIdValueChange(-1, "-1");
    // this.setState({ selectedPlanningId: {}});
    let date = getFirstMonday(this.state.semesterYear, 0);
    this.setStartDate(date);
    let firstDate = new Date(date.setMonth(date.getMonth() - 1));
    this.setFirstDate(firstDate);

    date = getFirstSunday(this.state.semesterYear, 6);
    this.setEndDate(date);

    this.setState({ runName: 'RUN-S1-' + this.state.semesterYear });
  };

  // setS2 = () => {
  //   const currentSemester = getSemester(new Date());
  //   let date;
  //   if (currentSemester.current === 'S2') {
  //     date = new Date();
  //     date.setDate(1);
  //     date.setMonth(8);
  //   } else {
  //     date = new Date();
  //     date.setDate(1);
  //     date.setMonth(3);
  //   }
  //   const semester = getSemester(new Date(date));
  //   this.setState({ lastDate: semester.endStr, startDate: semester.beginningStr, firstDate: semester.beginningStr.substr(0,5)+ "01-01", runName: 'RUN-'+semester.name })

  // };

  setS2 = () => {
    // this.handlePlanningIdValueChange(-1, "-1");
    // this.setState({ selectedPlanningId: {}});
    let date = getFirstMonday(this.state.semesterYear, 6);
    this.setStartDate(date);
    let firstDate = new Date(date.setMonth(date.getMonth() - 6));
    this.setFirstDate(firstDate);

    date = getFirstSunday(this.state.semesterYear + 1, 0);
    this.setEndDate(date);

    this.setState({ runName: 'RUN-S2-' + this.state.semesterYear });
  };

  setSemester = (data) => {
    const semester = getSemester(new Date(data));
    this.setState({
      lastDate: semester.endStr,
      startDate: semester.beginningStr,
      firstDate: semester.beginningStr,
      runName: 'RUN-' + semester.name,
    });
  };

  onFirstDateChange = (data) => {
    this.setState({ firstDate: data });
  };

  onFirstDateBlur = () => {
    const semester = getSemester(new Date(this.state.firstDate));
    this.setState({
      lastDate: semester.endStr,
      startDate: semester.beginningStr,
      firstDate: semester.beginningStr,
      runName: 'RUN-' + semester.name,
    });
  };

  setSemesterFilter = (data) => {
    this.setState({ semester: data });
  };

  setTypeToCopy = (data) => {
    this.setState({ typeToCopy: data });
  };

  setSemesterToCopy = (data) => {
    this.setState({ semesterToCopy: data });
  };

  setYearToCopyFrom = (data) => {
    this.setState({ yearToCopyFrom: data });
  };

  setYearToCopyTo = (data) => {
    this.setState({ yearToCopyTo: data });
  };

  copyBPOrDuties = async () => {
    this._isMounted && this.setState({ isLoading: true });
    await this.props.PlannerStore!.copyBPOrDuties(
      this.state.typeToCopy,
      this.state.semesterToCopy,
      this.state.yearToCopyFrom,
      this.state.yearToCopyTo,
    );
    this._isMounted && this.setState({ isLoading: false });
  };

  onLastDateChange = (data) => {
    this.setState({ lastDate: data });
  };

  onStartDateChange = (data) => {
    this.setState({ startDate: data });
  };

  onLevelModeChange = (data) => {
    this.setState({ levelMode: data });
  };

  onRunNameChange = (data) => {
    this.setState({ runName: data });
  };

  onRunDescriptionChange = (data) => {
    this.setState({ runDescription: data });
  };

  onCheckStartYearChanged = (data) => {
    this.setState({ checkStartYear: data });
  };

  onImportModalClose = () => {
    this.setState({
      modalFileLoadingOpened: false,
      fileIsLoading: false,
    });
  };

  getScores1 = async (runId) => {
    const scoreList = await this.props.PlannerStore!.getScoresByRunId(runId);
    let compositeScoreList: any[] = [];
    for (var i = 0; i < scoreList[0].length; i++) {
      const point = {
        key: scoreList[0][i].key,
        hard: scoreList[0][i].value,
        medium: scoreList[1][i].value,
        soft: scoreList[2][i].value,
      };
      compositeScoreList.push(point);
    }
    this._isMounted &&
      this.setState({
        scoreList1: compositeScoreList as any,
        scoreListH1: scoreList[0] as any,
        scoreListM1: scoreList[1] as any,
        scoreListS1: scoreList[2] as any,
      });
  };

  getScores2 = async (runId) => {
    const scoreList = await this.props.PlannerStore!.getScoresByRunId(runId);
    let compositeScoreList: any[] = [];
    for (var i = 0; i < scoreList[0].length; i++) {
      const point = {
        key: scoreList[0][i].key,
        hard: scoreList[0][i].value,
        medium: scoreList[1][i].value,
        soft: scoreList[2][i].value,
      };
      compositeScoreList.push(point);
    }
    this._isMounted &&
      this.setState({
        scoreList2: compositeScoreList as any,
        scoreListH2: scoreList[0] as any,
        scoreListM2: scoreList[1] as any,
        scoreListS2: scoreList[2] as any,
      });
  };

  getScoresByRunId = async (runId) => {
    const scoreList = await this.props.PlannerStore!.getScoresByRunId(runId);
    return scoreList;
  };

  render() {
    const { PlannerStore, AuthenticationStore, SecretariatStore, PushNotificationStore, translate } = this.props;
    const connectedUsers = PushNotificationStore!.userCount;
    const sessions = PushNotificationStore!.sessionList;
    let planningSaved = PushNotificationStore!.planningSaved;
    const pushedScore = PushNotificationStore!.score;
    const splitPushedScore = pushedScore.split(' ');
    const planningId = 1;
    const {
      secretariatId,
      annualReviewIssLoading,
      scoreRequestTime,
      matchRequestTime,
      indictmentRequestTime,
      prevScoreRequestTime,
      prevMatchRequestTime,
      prevIndictmentRequestTime,
      dutyAssignmentSaveRequestTime,
      fileIsLoading,
      modalFileLoadingOpened,
      dutiesImportError,
      loginState,
      hangfireState,
      prevRunning,
      prevTerminatedEarly,
      prevScore,
      prevMatchList,
      prevIndictmentList,
      saving,
      clearDutyAssignments,
      stopAfterOneSolution,
      solvingStart,
      scoreList,
      scoreList1,
      scoreListH1,
      scoreListM1,
      scoreListS1,
      scoreList2,
      scoreListH2,
      scoreListM2,
      scoreListS2,
      runId1,
      runId2,
      semester,
      typeToCopy,
      semesterToCopy,
      yearToCopyFrom,
      yearToCopyTo,
      prevCalcDuration,
      prevSolCount,
      calcDuration,
      solCount,
    } = this.state;

    // let list = new Array();
    // let i=0;
    // scoreList.forEach((value) => {
    //   list.push({ key: i, value: value });
    //   i += 1;
    // });
    // const scores = list;

    // list = new Array();
    // i=0;
    // scoreList1.forEach((value) => {
    //   list.push({ key: i, value: value });
    //   i += 1;
    // });
    // const scores1 = list;

    // list = new Array();
    // i=0;
    // scoreList2.forEach((value) => {
    //   list.push({ key: i, value: value });
    //   i += 1;
    // });
    // const scores2 = list;

    const plannerStatus = PlannerStore!.dataList;
    const status = plannerStatus[0];
    const running = plannerStatus[0]
      ? plannerStatus[0].status
        ? '' + plannerStatus[0].status.running
        : 'n/a2'
      : 'n/a';
    const terminatedEarly = plannerStatus[0]
      ? plannerStatus[0].status
        ? '' + plannerStatus[0].status.terminatedEarly
        : 'n/a2'
      : 'n/a';
    const score = plannerStatus[0]
      ? plannerStatus[0].status
        ? plannerStatus[0].status.currentBestScore
        : { hardScore: 'n/a', softScore: 'n/a', mediumScore: 'n/a' }
      : { hardScore: 'n/a', softScore: 'n/a', mediumScore: 'n/a' };

    const softColor = +splitPushedScore[2] > score.softScore! ? '#c0f939' : 'white';
    const mediumColor = +splitPushedScore[1] > score.mediumScore! ? '#c0f939' : 'white';
    const hardColor = +splitPushedScore[0] > score.hardScore! ? '#c0f939' : 'white';

    const runId = plannerStatus[0] ? plannerStatus[0].status.runId : 'n/a';
    const startedOn = plannerStatus[0] ? plannerStatus[0].status.startedOn : 'n/a';
    const firstDD = plannerStatus[0] ? plannerStatus[0].status.firstDD : '';
    const startDD = plannerStatus[0] ? plannerStatus[0].status.startDD : '';
    const lastDD = plannerStatus[0] ? plannerStatus[0].status.lastDD : '';
    const explanation = plannerStatus[0] ? plannerStatus[0].explanation : 'n/a';
    const returnCode = plannerStatus[0] ? plannerStatus[0].return : 'n/a';
    const newTime = new Date();
    const time = newTime.toLocaleString();
    const matchList = plannerStatus[0] ? plannerStatus[0].matchList : ['n/a'];
    const indictmentList = plannerStatus[0] ? plannerStatus[0].indictmentList : ['n/a'];
    const newDate = new Date();
    const date = newDate.toLocaleString();
    const solving = solvingStart.toLocaleString();
    // const startedOnDate = new Date(startedOn); // moment(startedOn, "MM-DD-YYYY hh:mm:ss").format("YYYY-MM-DD hh:mm:ss"); //.toDate()
    const duration = newDate.getTime() - new Date(startedOn).getTime(); //new Date(solvingStart).getTime();
    const seconds = moment.duration(duration).seconds();
    const minutes = moment.duration(duration).minutes();
    const hours = moment.duration(duration).hours();
    const days = moment.duration(duration).days();
    const year = this.state.semesterYear;
    const chDuration = this.state.chDuration;

    const lastCalcSpeed = (solCount - prevSolCount) / (calcDuration - prevCalcDuration);
    const avgCalcSpeed = solCount / calcDuration;

    return (
      <MainSectionLayout isLoading={this.state.isLoading} title={TLCode.PLANNER_Title}>
        <Container>
          <Card className={CardStyle.toString()}>
            <DivLine>
              <DivColumn
                style={{
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <b>
                  &nbsp;
                  <TranslatedMessage id={TLCode.UNAVAILABILITY_LoginStatus} />
                  &nbsp;
                </b>
                {loginState ? loginState[0].status : ''}
              </DivColumn>
              <DivColumn>
                <ButtonGroup>
                  <Button intent="success" onClick={this.authorizeLogin}>
                    {' '}
                    <TranslatedMessage id={TLCode.UNAVAILABILITY_AuthorizeLogin} />
                  </Button>
                  <Button intent="warning" onClick={this.limitLogin}>
                    {' '}
                    <TranslatedMessage id={TLCode.UNAVAILABILITY_LimitLogin} />
                  </Button>
                  <Button intent="danger" onClick={this.minimalLogin}>
                    {' '}
                    <TranslatedMessage id={TLCode.UNAVAILABILITY_MinimalLogin} />
                  </Button>
                </ButtonGroup>
                {/* &nbsp;
              <b>{loginState ? loginState[0].status : ''}</b> */}
              </DivColumn>
              <DivColumn
                style={{
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <b>&nbsp;Connected users&nbsp;</b>
                {connectedUsers}
              </DivColumn>
              <DivColumn style={{ width: '150px' }}>
                <Select options={sessions} />
              </DivColumn>
              <DivColumn
                style={{
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <b>&nbsp;Hangfire&nbsp;</b>
                {hangfireState ? hangfireState[0].status : ''}
              </DivColumn>
              <DivColumn>
                <ButtonGroup>
                  <Button intent="success" onClick={this.startHangfire}>
                    {' '}
                    <TranslatedMessage id={TLCode.HANGFIRE_Start} />
                  </Button>
                  <Button intent="warning" onClick={this.stopHangfire}>
                    {' '}
                    <TranslatedMessage id={TLCode.HANGFIRE_Stop} />
                  </Button>
                </ButtonGroup>
              </DivColumn>
              <DateInput
                formatDate={(date, locale) => date.toLocaleString(locale)}
                locale={'fr-BE'}
                value={this.state.restartDate}
                timePrecision={'minute'}
                disabled={false}
                onChange={(date) => this.setState({ restartDate: date })}
              />
              &nbsp;
              <InputGroup
                placeholder="Enter notif. text"
                value={this.state.notification}
                onChange={(e) => this.onNotificationChange(e.target.value)}
              />
              &nbsp;
              <Button intent="success" onClick={this.pushNotification}>
                {' '}
                <TranslatedMessage id={TLCode.PUSH_NOTIFICATION_Push} />
              </Button>
            </DivLine>
            <br />
            <DivLine>
              <DivColumn>
                <TranslatedMessage id={TLCode.ROSTER_Year} />
                <NumericInput
                  style={{ width: '60px' }}
                  min={2016}
                  value={year}
                  onValueChange={this.handleSemesterYearValueChange}
                />
              </DivColumn>
              <DivColumn style={{ marginLeft: '2px' }}>
                <TranslatedMessage id={TLCode.ROSTER_Semester} />
                <ButtonGroup>
                  <Button intent="primary" onClick={this.setS1}>
                    <TranslatedMessage id={TLCode.ROSTER_S1} />
                  </Button>
                  &nbsp;&nbsp;
                  <Button intent="primary" onClick={this.setS2}>
                    <TranslatedMessage id={TLCode.ROSTER_S2} />
                  </Button>
                </ButtonGroup>
              </DivColumn>
              {/* </DivLine>
            <DivLine> */}
              <DivColumn style={{ width: '120px', marginRight: '3px' }}>
                Première date
                <InputGroup
                  // placeholder="2019-12-01"
                  value={this.state.firstDate}
                  onChange={(e) => this.onFirstDateChange(e.target.value)}
                // onBlur={() => this.onFirstDateBlur()}
                />
              </DivColumn>
              <DivColumn style={{ width: '120px', marginRight: '3px' }}>
                Début du planning
                <InputGroup
                  // placeholder="2020-01-02"
                  value={this.state.startDate}
                  onChange={(e) => this.onStartDateChange(e.target.value)}
                />
              </DivColumn>
              <DivColumn style={{ width: '120px', marginRight: '3px' }}>
                Dernière date
                <InputGroup
                  // placeholder="2020-03-31"
                  value={this.state.lastDate}
                  onChange={(e) => this.onLastDateChange(e.target.value)}
                />
              </DivColumn>
              <DivColumn style={{ marginRight: '3px' }}>
                Titre du run
                <InputGroup
                  placeholder="Enter run name"
                  value={this.state.runName} // + '-' + this.state.semester + '-' + this.state.semesterYear}
                  onChange={(e) => this.onRunNameChange(e.target.value)}
                />
              </DivColumn>
              <DivColumn style={{ width: '200px' }}>
                <DivLine>
                  Description
                  <InputGroup
                    placeholder="Enter description"
                    value={this.state.runDescription}
                    onChange={(e) => this.onRunDescriptionChange(e.target.value)}
                  />
                </DivLine>
                <DivLine>
                  Groups
                  <InputGroup
                    placeholder="Enter comma separated group list"
                    value={this.state.calcGroups}
                    onChange={(e) => this.setState({ calcGroups: e.target.value })}
                  />
                </DivLine>
              </DivColumn>
              {/* <DivColumn>
                <TranslatedMessage id={TLCode.ROSTER_ConstructionHeuristicDuration} />
                <NumericInput
                  style={{ width: '60px' }}
                  min={0}
                  value={chDuration}
                  onValueChange={this.handleCHDurationValueChange}
                />
              </DivColumn> */}
              <DivColumn>
                <br />
                <Checkbox
                  onChange={() => this.setState({ clearDutyAssignments: !this.state.clearDutyAssignments })}
                  checked={this.state.clearDutyAssignments}
                  style={{ marginLeft: '5px', marginRight: '10px' }}
                >
                  Clear DA
                </Checkbox>
                <Checkbox
                  onChange={() => this.setState({ stopAfterOneSolution: !this.state.stopAfterOneSolution })}
                  checked={this.state.stopAfterOneSolution}
                  style={{ marginLeft: '5px', marginRight: '10px' }}
                >
                  StartStop
                </Checkbox>
              </DivColumn>
              <DivColumn>
                <br />
                <ButtonGroup>
                  <Button intent="success" onClick={this.startPlanner}>
                    <TranslatedMessage id={TLCode.ROSTER_Start} />
                  </Button>
                </ButtonGroup>
              </DivColumn>
              <DivColumn>
                <br />
                <ButtonGroup>
                  <Button intent="danger" onClick={this.takeSnapshot}>
                    <TranslatedMessage id={TLCode.ROSTER_TakeSnapshot} />
                  </Button>
                </ButtonGroup>
              </DivColumn>
              <DivColumn>
                <br />
                <ButtonGroup>
                  <Button intent="danger" onClick={this.assessPlanning}>
                    <TranslatedMessage id={TLCode.ROSTER_AssessPlanning} />
                  </Button>
                </ButtonGroup>
              </DivColumn>
              {/* <DivColumn style={{ marginLeft: '50px' }}>
                <br />
                <Button
                  intent="danger"
                  onClick={() => this.props.PushNotificationStore!.connect(this.props.AuthenticationStore!.userName)}
                >
                  <TranslatedMessage id={TLCode.ROSTER_Reconnect} />
                </Button>
              </DivColumn> */}
            </DivLine>
            <DivLine>
              <DivColumn style={{ width: '500px' }} />
              <Checkbox
                onChange={() => this.setState({ calcUphoc: !this.state.calcUphoc })}
                checked={this.state.calcUphoc}
                style={{ marginLeft: '5px', marginRight: '10px' }}
              >
                calc.Uphoc
              </Checkbox>
              <Checkbox
                onChange={() => this.setState({ calcCerpan: !this.state.calcCerpan })}
                checked={this.state.calcCerpan}
                style={{ marginLeft: '5px', marginRight: '10px' }}
              >
                calc.Cerpan
              </Checkbox>
              <Checkbox
                onChange={() => this.setState({ calcUrpc: !this.state.calcUrpc })}
                checked={this.state.calcUrpc}
                style={{ marginLeft: '5px', marginRight: '10px' }}
              >
                calc.Urpc
              </Checkbox>
              <Checkbox
                onChange={() => this.setState({ calcApnl: !this.state.calcApnl })}
                checked={this.state.calcApnl}
                style={{ marginLeft: '5px', marginRight: '10px' }}
              >
                calc.Apnl
              </Checkbox>
              <Checkbox
                onChange={() => this.setState({ calcAppl: !this.state.calcAppl })}
                checked={this.state.calcAppl}
                style={{ marginLeft: '5px', marginRight: '10px' }}
              >
                calc.Appl
              </Checkbox>
            </DivLine>
            <br />
            <Collapse isOpen={this.state.isOpen}>
              <DivLine>
                <ButtonGroup>
                  <Button intent="primary" onClick={this.suspendPlanner}>
                    <TranslatedMessage id={TLCode.ROSTER_Suspend} />
                  </Button>
                  <Button intent="success" onClick={this.resumePlanner}>
                    <TranslatedMessage id={TLCode.ROSTER_Resume} />
                  </Button>
                  <Button intent="danger" onClick={this.stopPlanner}>
                    <TranslatedMessage id={TLCode.ROSTER_Stop} />
                  </Button>
                  <Button intent="primary" onClick={this.getPlannerStatus}>
                    <TranslatedMessage id={TLCode.ROSTER_GetStatus} />
                  </Button>
                  {/* <Button intent="primary" onClick={this.getScore}>
                    <TranslatedMessage id={TLCode.ROSTER_GetScore} />
                  </Button> */}
                  {/* <Button intent="primary" onClick={this.explainScore} disabled>
                    <TranslatedMessage id={TLCode.ROSTER_ExplainScore} />
                  </Button> */}
                  <Button intent="primary" onClick={this.getConstraintMatchTotal}>
                    <TranslatedMessage id={TLCode.ROSTER_ShowMatches} />
                  </Button>
                  {/* <Button intent="primary" onClick={this.getScoreExplanation}>
                    <TranslatedMessage id={TLCode.ROSTER_ShowExplanation} />
                  </Button>
                  <Button intent="primary" onClick={this.getIndictmentMap}>
                    <TranslatedMessage id={TLCode.ROSTER_ShowIndictments} />
                  </Button> */}
                  {/* <Button intent="primary" onClick={this.saveDutyAssignments}>
                    <TranslatedMessage id={TLCode.ROSTER_SaveDutyAssignments} />
                  </Button> */}

                  <ButtonGroup>
                    <Button intent="success" onClick={this.savePlanning}>
                      <TranslatedMessage id={TLCode.ROSTER_SavePlanning} />
                    </Button>
                  </ButtonGroup>
                  <InputGroup
                    placeholder="planningId à promouvoir en LIVE"
                    value={this.state.planningIdToPromote}
                    onChange={(e) => this.setState({ planningIdToPromote: e.target.value })}
                  />
                  <ButtonGroup>
                    <Button intent="danger" onClick={this.promotePlanning}>
                      <TranslatedMessage id={TLCode.ROSTER_PromotePlanning} />
                    </Button>
                  </ButtonGroup>

                  {saving && <Spinner />}
                  {saving && <Button intent="success" />}
                  {!saving && <Button intent="danger" />}
                  {!planningSaved && <Button intent="danger" />}
                  {planningSaved && <Button intent="success" />}
                  {/* <Button intent="primary" icon="refresh" /> */}
                  {/* <Button intent="primary" onClick={this.publishPlanning}>
                    <TranslatedMessage id={TLCode.ROSTER_PublishPlanning} />
                  </Button> */}
                  <DivColumn style={{ marginLeft: '50px' }}>
                    <Button
                      intent="danger"
                      onClick={() =>
                        this.props.PushNotificationStore!.connect(this.props.AuthenticationStore!.userName)
                      }
                    >
                      <TranslatedMessage id={TLCode.ROSTER_Reconnect} />
                    </Button>
                  </DivColumn>
                </ButtonGroup>
              </DivLine>
              <br />
              <DivLine>
                <DivColumn style={{ width: '650px' }}>
                  <DivLine>
                    <DivColumn>**first :&nbsp;{firstDD}&nbsp;</DivColumn>
                    <DivColumn>**start :&nbsp;{startDD}&nbsp;</DivColumn>
                    <DivColumn>**last :&nbsp;{lastDD}&nbsp;</DivColumn>
                    <DivColumn>**runId :&nbsp;{runId}&nbsp;</DivColumn>
                  </DivLine>
                  <DivLine>
                    **started@&nbsp;{startedOn}&nbsp;** {days} day(s)&nbsp;{hours}:{minutes}:{seconds} **avg speed:
                    {Math.round(avgCalcSpeed)}
                  </DivLine>
                  {/* <DivLine>**started@&nbsp;{startedOn}{solving}&nbsp;** {days} day(s)&nbsp;{hours}:{minutes}:{seconds}</DivLine> */}
                  <DivLine>**saved@&nbsp;{dutyAssignmentSaveRequestTime}&nbsp;**</DivLine>
                  <DivLine>{returnCode}</DivLine>
                  <br />
                  <DivLine>
                    **running:{running}&nbsp;&nbsp;&nbsp;terminatedEarly:{terminatedEarly}**last speed:
                    {Math.round(lastCalcSpeed)}
                  </DivLine>
                  <DivLine>
                    **pushed score:&nbsp;
                    <span style={{ background: hardColor }}>{formatNumber(Number(splitPushedScore[0]),2, 'en-US')}</span>&nbsp;
                    <span style={{ background: mediumColor }}>{formatNumber(Number(splitPushedScore[1]),2, 'en-US')}</span>&nbsp;
                    <span style={{ background: softColor }}>{formatNumber(Number(splitPushedScore[2]),2, 'en-US')}</span>
                    &nbsp;@&nbsp;{date}
                    **
                    {/* **pushed score:{pushedScore} @ {date}** */}
                  </DivLine>
                  <DivLine>
                    **pulled score&nbsp;:&nbsp;&nbsp;{formatNumber(Number(score.hardScore),2, 'en-US')}{' '}
                    {formatNumber(Number(score.mediumScore),2, 'en-US')} {formatNumber(Number(score.softScore),2, 'en-US')}
                    &nbsp;@&nbsp;{scoreRequestTime}**{Math.round(calcDuration)}##{solCount}
                  </DivLine>
                </DivColumn>
                <DivColumn style={{ width: '650px' }}>
                  <DivLine>&nbsp;</DivLine>
                  <DivLine>**</DivLine>
                  <DivLine>**</DivLine>
                  <DivLine>**</DivLine>
                  <DivLine>**</DivLine>
                  <DivLine>**</DivLine>
                  {/* <DivLine>**</DivLine> */}
                  <DivLine>
                    **pulled score:{prevScore ? formatNumber(Number(prevScore.hardScore), 2, 'en-US') : 'n/a'}{' '}
                    {prevScore ? formatNumber(Number(prevScore.mediumScore), 2, 'en-US') : 'n/a'} {prevScore ? formatNumber(Number(prevScore.softScore), 2, 'en-US') : 'n/a'}{' '}
                    {Math.round(prevCalcDuration)}##{prevSolCount} @ {prevScoreRequestTime}**
                  </DivLine>
                </DivColumn>
              </DivLine>
              <br />
              <DivLine>
                <DivColumn style={{ width: '750px' }}>**matches @ {matchRequestTime}**</DivColumn>
                <DivColumn>**matches @ {prevMatchRequestTime}**</DivColumn>
              </DivLine>
              <DivLine>

                <DivColumn style={{ width: '200px' }}>
                  {Array.from(this.state.ruleSet.entries()).map((entry) => {
                    let value : string | number | undefined = this.state.ruleScores.get(entry[0]);
                    let prevValue : string | number | undefined = this.state.prevRuleScores.get(entry[0]);
                    let rest;
                    let prevRest;
                    if (value) {
                      [value, rest] = value.split("hard/");
                      value = Number(value);
                    }
                    if (prevValue) {
                      [prevValue, prevRest] = prevValue.split("hard/");
                      prevValue = Number(prevValue)
                    }
                    return (
                      <>
                        <li key={entry[0]}>
                          <DivLine>
                            {value! > prevValue! && (
                              <DivColumn
                                  style={{
                                      display: 'flex',
                                      color: 'lightgreen',
                                      fontWeight: 'bold',
                                      flexDirection: 'row',
                                    }}>
                                <span style={{width: '13ch', textAlign: 'right'}}>{value ? value : '-'}</span>
                                <span>hard/{rest}</span>
                              </DivColumn>
                            )}
                            {(value == undefined || prevValue == undefined || value! == prevValue!) && (
                              <DivColumn
                                  style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  }}>
                                <span style={{width: '13ch', textAlign: 'right'}}>{value == '' ? "0": value}</span>
                                <span>hard/{rest}</span>
                              </DivColumn>
                            )}
                            {value! < prevValue! && (
                              <DivColumn
                                  style={{
                                      display: 'flex',
                                      color: 'pink',
                                      fontWeight: 'bold',
                                      flexDirection: 'row',
                                    }}
                              >
                                <span style={{width: '13ch', textAlign: 'right'}}>{value ? value : '-'}</span>
                                <span>hard/{rest}</span>
                              </DivColumn>
                            )}
                          </DivLine>
                        </li>
                      </>
                    );
                    // return<><li key={value[0]}><DivLine><DivColumn>{value[1]}</DivColumn></DivLine></li></>
                  } )}
                </DivColumn>

                {/* <DivColumn style={{ width: '200px' }}>
                  {Array.from(this.state.ruleSet.entries()).map((entry) => {
                    const value = this.state.ruleScores.get(entry[0]);
                    const prevValue = this.state.prevRuleScores.get(entry[0]);
                    return (
                      <>
                        <li key={entry[0]}>
                          <DivLine>
                            {value! < prevValue! && (
                              <DivColumn
                                  style={{
                                      width: '30px',
                                      textAlign: 'right',
                                      color: 'lightgreen',
                                      fontWeight: 'bold',
                                    }}
                              >{value ? value : '-'}</DivColumn>
                            )}
                            {(value == undefined || prevValue == undefined || value! == prevValue!) && (
                              <DivColumn>{value ? value : '-'}</DivColumn>
                            )}
                            {value! > prevValue! && (
                              <DivColumn
                                  style={{
                                      width: '30px',
                                      textAlign: 'right',
                                      color: 'pink',
                                      fontWeight: 'bold',
                                    }}
                              >{value ? value : '-'}</DivColumn>
                            )}
                          </DivLine>
                        </li>
                      </>
                    );
                    // return<><li key={value[0]}><DivLine><DivColumn>{value[1]}</DivColumn></DivLine></li></>
                  })}
                </DivColumn> */}
                <DivColumn>
                  {Array.from(this.state.ruleSet.entries()).map((value) => {
                    const prevValue = this.state.prevRuleCounts.get(value[0]);
                    return (
                      <>
                        <li key={value[0]}>
                          <DivLine>
                            <DivColumn style={{ width: '340px', textAlign: 'right' }}>
                              {value[0]}&nbsp;##&nbsp;
                            </DivColumn>
                            {value[1] < prevValue! && (
                              <DivColumn
                                style={{
                                  width: '30px',
                                  textAlign: 'right',
                                  color: 'lightgreen',
                                  fontWeight: 'bold',
                                }}
                              >
                                {value[1]}
                              </DivColumn>
                            )}
                            {value[1] > prevValue! && (
                              <DivColumn
                                style={{ width: '30px', textAlign: 'right', color: 'red', fontWeight: 'bold' }}
                              >
                                {value[1]}
                              </DivColumn>
                            )}
                            {(prevValue! == undefined || value[1] == prevValue!) && (
                              <DivColumn
                                style={{ width: '30px', textAlign: 'right', color: 'black', fontWeight: 'normal' }}
                              >
                                {value[1]}
                              </DivColumn>
                            )}
                          </DivLine>
                        </li>
                      </>
                    );
                  })}
                </DivColumn>
                <DivColumn style={{ width: '200px'}}>
                  {/* {Array.from(this.state.prevRuleCounts.entries()).map((value) =>  */}
                  {Array.from(this.state.ruleSet.entries()).map((entry) => {
                    const curValue = this.state.ruleSet.get(entry[0]);
                    const value = this.state.prevRuleCounts.get(entry[0]);
                    return (
                      <>
                        <li key={entry[0]}>
                          <DivLine>
                            <DivColumn style={{ width: '20px', textAlign: 'right' }}>&nbsp;--&nbsp;</DivColumn>
                            <DivColumn style={{ width: '40px', textAlign: 'right' }}>
                              {value ? value : '-'}&nbsp;#&nbsp;
                            </DivColumn>
                          </DivLine>
                        </li>
                      </>
                    );
                    // return <><li key={value[0]}><DivLine><DivColumn style={{ width: '20px', textAlign: 'right' }}>&nbsp;--&nbsp;</DivColumn><DivColumn style={{ width: '40px', textAlign: 'right' }}>{value[1]}</DivColumn></DivLine></li></>
                  })}
                </DivColumn>
                <DivColumn>
                  {/* {Array.from(this.state.prevRuleScores.entries()).map((value) =>  */}
                  {Array.from(this.state.ruleSet.entries()).map((entry) => {
                    let value = this.state.prevRuleScores.get(entry[0]);
                    let rest;
                    if (value) [value, rest] = value.split("hard/");
                    return (
                      <>
                        <li key={entry[0]}>
                          <DivLine>
                            <DivColumn
                                  style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  }}>
                                <span style={{width: '16ch', textAlign: 'right'}}>{value ? value : '-'}</span>
                                <span>hard/{rest}</span>
                            </DivColumn>
                            {/* <DivColumn>&nbsp;#&nbsp;{value}</DivColumn> */}
                          </DivLine>
                        </li>
                      </>
                    );
                  })}
                </DivColumn>
              </DivLine>
              <br />
              <DivLine>
                <DivColumn>
                  <br />
                  <DivLine>
                    <div>
                      **indictments @ {indictmentRequestTime}**
                      {indictmentList.map((item, index) => (
                        <li key={item}>{item}</li>
                      ))}
                    </div>
                  </DivLine>
                </DivColumn>
                <DivColumn>&nbsp;</DivColumn>
                <DivColumn>
                  <br />
                  <DivLine>
                    <div>
                      **indictments @ {prevIndictmentRequestTime}**
                      {prevIndictmentList.map((item, index) => (
                        <li key={item}>{item}</li>
                      ))}
                    </div>
                  </DivLine>
                </DivColumn>
              </DivLine>
              <DivLine>
                {' '}
                {/* courbes */}
                <DivColumn style={{ width: '50%' }}>
                  {' '}
                  {/* gauche */}
                  <DivLine>
                    <InputGroup
                      placeholder="runId"
                      value={this.state.runId1}
                      onChange={(e) => this.setState({ runId1: e.target.value })}
                      onBlur={() => this.getScores1(this.state.runId1)}
                    />
                    <Button
                      intent="danger"
                      onClick={() => this.getScores1(this.state.runId1)}
                      icon="refresh"
                      style={{ marginLeft: '4px' }}
                    >
                      {/* <TranslatedMessage id={TLCode.GENERAL_Refresh} /> */}
                    </Button>
                  </DivLine>
                  <DivLine>
                    <ResponsiveContainer width="100%" height={200}>
                      <LineChart
                        height={250}
                        data={scoreList1}
                        syncId="anyId"
                        margin={{
                          top: 5,
                          right: 0,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                          dataKey="key"
                          type="number"
                          scale="time"
                          padding={{ left: 5 }}
                          interval={50}
                          angle={-45}
                          domain={[0, 'dataMax']}
                        />
                        <YAxis >{/* <ChartLabel value="Phies" position="insideLeft" offset={-10} /> */}</YAxis>
                        <ChartTooltip />
                        <Legend />
                        <Line
                          type="monotone"
                          dataKey="hard"
                          name="Hardscore"
                          stroke="#8884d8"
                          activeDot={{ r: 2 }}
                        />
                        <Line
                          type="monotone"
                          dataKey="medium"
                          name="Mediumscore"
                          stroke="#FF00FF"
                          activeDot={{ r: 2 }}
                        />
                        <Line
                          type="monotone"
                          dataKey="soft"
                          name="Softscore"
                          stroke="#00FFFF"
                          activeDot={{ r: 1 }}
                        />
                        <ChartTooltip />
                      </LineChart>
                    </ResponsiveContainer>
                  </DivLine>
                  <DivLine>
                    <ResponsiveContainer width="100%" height={200}>
                      <LineChart
                        // width={500}
                        height={250}
                        data={scoreListH1}
                        syncId="anyId"
                        // data={scores}
                        margin={{
                          top: 5,
                          right: 0,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                          dataKey="key"
                          type="number"
                          scale="time"
                          padding={{ left: 2 }}
                          interval={50}
                          angle={-45}
                          domain={[0, 'dataMax']}
                        />
                        <YAxis>{/* <ChartLabel value="Phies" position="insideLeft" offset={-10} /> */}</YAxis>
                        <ChartTooltip />
                        <Legend />
                        <Line
                          type="monotone"
                          dataKey="value"
                          name="Hardscore"
                          stroke="#8884d8"
                          activeDot={{ r: 2 }}
                        />
                        <ChartTooltip />
                      </LineChart>
                    </ResponsiveContainer>
                  </DivLine>
                  <DivLine>
                    <ResponsiveContainer width="100%" height={200}>
                      <LineChart
                        // width={500}
                        height={250}
                        data={scoreListM1}
                        syncId="anyId"
                        // data={scores}
                        margin={{
                          top: 5,
                          right: 0,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                          dataKey="key"
                          type="number"
                          scale="time"
                          padding={{ left: 2 }}
                          interval={50}
                          angle={-45}
                          domain={[0, 'dataMax']}
                        />
                        <YAxis>{/* <ChartLabel value="Phies" position="insideLeft" offset={-10} /> */}</YAxis>
                        <ChartTooltip />
                        <Legend />
                        <Line
                          type="monotone"
                          dataKey="value"
                          name="Mediumscore"
                          stroke="#8884d8"
                          activeDot={{ r: 2 }}
                        />
                        <ChartTooltip />
                      </LineChart>
                    </ResponsiveContainer>
                  </DivLine>
                  <DivLine>
                    <ResponsiveContainer width="100%" height={200}>
                      <LineChart
                        // width={500}
                        height={250}
                        data={scoreListS1}
                        syncId="anyId"
                        // data={scores}
                        margin={{
                          top: 5,
                          right: 0,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                          dataKey="key"
                          type="number"
                          scale="time"
                          padding={{ left: 2 }}
                          interval={50}
                          angle={-45}
                          domain={[0, 'dataMax']}
                        />
                        <YAxis>{/* <ChartLabel value="Phies" position="insideLeft" offset={-10} /> */}</YAxis>
                        <ChartTooltip />
                        <Legend />
                        <Line
                          type="monotone"
                          dataKey="value"
                          name="Softscore"
                          stroke="#8884d8"
                          activeDot={{ r: 2 }}
                        />
                        <ChartTooltip />
                      </LineChart>
                    </ResponsiveContainer>
                  </DivLine>
                </DivColumn>
                <DivColumn style={{ width: '50%' }}>
                  {' '}
                  {/* droite */}
                  <DivLine>
                    <InputGroup
                      placeholder="runId"
                      value={this.state.runId2}
                      onChange={(e) => this.setState({ runId2: e.target.value })}
                      onBlur={() => this.getScores2(this.state.runId2)}
                    />
                    <Button
                      intent="danger"
                      onClick={() => this.getScores2(this.state.runId2)}
                      icon="refresh"
                      style={{ marginLeft: '4px' }}
                    >
                      {/* <TranslatedMessage id={TLCode.GENERAL_Refresh} /> */}
                    </Button>
                  </DivLine>
                  <DivLine>
                    <ResponsiveContainer width="100%" height={200}>
                      <LineChart
                        height={250}
                        data={scoreList2}
                        syncId="anyId"
                        margin={{
                          top: 5,
                          right: 0,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                          dataKey="key"
                          type="number"
                          scale="time"
                          padding={{ left: 2 }}
                          interval={50}
                          angle={-45}
                          domain={[0, 'dataMax']}
                        />
                        <YAxis>{/* <ChartLabel value="Phies" position="insideLeft" offset={-10} /> */}</YAxis>
                        <ChartTooltip />
                        <Legend />
                        <Line
                          type="monotone"
                          dataKey="hard"
                          name="Hardscore"
                          stroke="#8884d8"
                          activeDot={{ r: 2 }}
                        />
                        <Line
                          type="monotone"
                          dataKey="medium"
                          name="Mediumscore"
                          stroke="#FF00FF"
                          activeDot={{ r: 2 }}
                        />
                        <Line
                          type="monotone"
                          dataKey="soft"
                          name="Softscore"
                          stroke="#00FFFF"
                          activeDot={{ r: 2 }}
                        />
                        <ChartTooltip />
                      </LineChart>
                    </ResponsiveContainer>
                  </DivLine>{' '}
                  <DivLine>
                    <ResponsiveContainer width="100%" height={200}>
                      <LineChart
                        // width={500}
                        height={250}
                        data={scoreListH2}
                        syncId="anyId"
                        // data={scores}
                        margin={{
                          top: 5,
                          right: 0,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                          dataKey="key"
                          type="number"
                          scale="time"
                          padding={{ left: 2 }}
                          interval={50}
                          angle={-45}
                        />
                        <YAxis>{/* <ChartLabel value="Phies" position="insideLeft" offset={-10} /> */}</YAxis>
                        <ChartTooltip />
                        <Legend />
                        <Line
                          type="monotone"
                          dataKey="value"
                          name="Hardscore"
                          stroke="#8884d8"
                          activeDot={{ r: 2 }}
                        />
                        <ChartTooltip />
                      </LineChart>
                    </ResponsiveContainer>
                  </DivLine>
                  <DivLine>
                    <ResponsiveContainer width="100%" height={200}>
                      <LineChart
                        // width={500}
                        height={250}
                        data={scoreListM2}
                        syncId="anyId"
                        // data={scores}
                        margin={{
                          top: 5,
                          right: 0,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                          dataKey="key"
                          type="number"
                          scale="time"
                          padding={{ left: 2 }}
                          interval={50}
                          angle={-45}
                        />
                        <YAxis>{/* <ChartLabel value="Phies" position="insideLeft" offset={-10} /> */}</YAxis>
                        <ChartTooltip />
                        <Legend />
                        <Line
                          type="monotone"
                          dataKey="value"
                          name="Mediumscore"
                          stroke="#8884d8"
                          activeDot={{ r: 2 }}
                        />
                        <ChartTooltip />
                      </LineChart>
                    </ResponsiveContainer>
                  </DivLine>
                  <DivLine>
                    <ResponsiveContainer width="100%" height={200}>
                      <LineChart
                        // width={500}
                        height={250}
                        data={scoreListS2}
                        syncId="anyId"
                        // data={scores}
                        margin={{
                          top: 5,
                          right: 0,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                          dataKey="key"
                          type="number"
                          scale="time"
                          padding={{ left: 2 }}
                          interval={50}
                          angle={-45}
                        />
                        <YAxis>{/* <ChartLabel value="Phies" position="insideLeft" offset={-10} /> */}</YAxis>
                        <ChartTooltip />
                        <Legend />
                        <Line
                          type="monotone"
                          dataKey="value"
                          name="Softscore"
                          stroke="#8884d8"
                          activeDot={{ r: 2 }}
                        />
                        <ChartTooltip />
                      </LineChart>
                    </ResponsiveContainer>
                  </DivLine>
                </DivColumn>
              </DivLine>
              <DivLine>
                <DivColumn>
                  <SimpleTextFormContent>
                    <RadioGroup
                      selectedValue={typeToCopy}
                      onChange={(data) => this.setTypeToCopy(data.currentTarget.value)}
                      inline
                    >
                      <Radio key={'bp'} label={translate(TLCode.ROSTER_COPYBP)} value="bp" alignIndicator="right" />
                      &nbsp;
                      <Radio
                        key={'duties'}
                        label={translate(TLCode.ROSTER_COPYLVL1DUTIES)}
                        value="duties"
                        alignIndicator="right"
                      />
                    </RadioGroup>
                  </SimpleTextFormContent>
                </DivColumn>
                <DivColumn>#####</DivColumn>
                <DivColumn>
                  <SimpleTextFormContent>
                    <RadioGroup
                      selectedValue={semesterToCopy}
                      onChange={(data) => this.setSemesterToCopy(data.currentTarget.value)}
                      inline
                    >
                      <Radio key={'S1'} label={translate(TLCode.ROSTER_S1)} value="S1" alignIndicator="right" />
                      &nbsp;&nbsp;&nbsp;
                      <Radio key={'S2'} label={translate(TLCode.ROSTER_S2)} value="S2" alignIndicator="right" />
                    </RadioGroup>
                  </SimpleTextFormContent>
                </DivColumn>
                <DivColumn>
                  <Label>Année source&nbsp;</Label>
                </DivColumn>
                <DivColumn>
                  <InputGroup
                    placeholder="année source"
                    value={this.state.yearToCopyFrom}
                    onChange={(e) => this.setYearToCopyFrom(e.target.value)}
                  />
                </DivColumn>
                <DivColumn>
                  <Label>&nbsp;&nbsp;Année cible&nbsp;</Label>
                </DivColumn>
                <DivColumn>
                  <InputGroup
                    placeholder="année cible"
                    value={this.state.yearToCopyTo}
                    onChange={(e) => this.setYearToCopyTo(e.target.value)}
                  />
                </DivColumn>
                <DivColumn>
                  <Button intent="danger" onClick={this.copyBPOrDuties}>
                    <TranslatedMessage id={TLCode.ROSTER_CopyBPOrDuties} />
                  </Button>
                </DivColumn>
              </DivLine>
              <br />
              <br />
              <DivLine>
                <ButtonGroup>
                  {/* <Button intent="primary" onClick={this.savePlanningData}>
                    <TranslatedMessage id={TLCode.ROSTER_SavePlanningData} />
                  </Button> */}
                  <Button intent="primary" onClick={this.serializeSolution}>
                    <TranslatedMessage id={TLCode.ROSTER_SerializeSolution} />
                  </Button>
                  <Button intent="primary" onClick={this.reloadSolution}>
                    <TranslatedMessage id={TLCode.ROSTER_ReloadSolution} />
                  </Button>
                  <Button intent="primary" onClick={this.initializeHangfire}>
                    <TranslatedMessage id={TLCode.ROSTER_InitializeDownloadPharmacyData} />
                  </Button>
                  <Button intent="primary" onClick={this.downloadAdjacentPharmacyData}>
                    <TranslatedMessage id={TLCode.ROSTER_InitializeDownloadAdjacentPharmacyData} />
                  </Button>
                  {/* <Button intent="primary" icon="refresh" /> */}
                </ButtonGroup>
                &nbsp;&nbsp;{this.props.ApplicationStore!.database}
              </DivLine>
              <DivLine>
                <TranslatedMessage id={TLCode.ROSTER_ReloadSolution} />
                <FileInput fill={true} onChange={this.handleKryoFileTextChange} text={this.state.kryoFileName} />
                <Button intent="primary" onClick={this.reloadSolution}>
                  <TranslatedMessage id={TLCode.ROSTER_ReloadSolution} />
                </Button>
              </DivLine>
              <br />
              <DivLine>
                <ButtonGroup>
                  <Button intent="primary" onClick={this.downloadDutyAssignments}>
                    <TranslatedMessage id={TLCode.ROSTER_DownloadDutyAssignments} />
                  </Button>
                  <Button intent="danger" onClick={this.replicateLevel1DutyAssignments}>
                    <TranslatedMessage id={TLCode.ROSTER_ReplicateLevel1DutyAssignments} />
                  </Button>
                </ButtonGroup>
              </DivLine>
              <br />
              <DivLine>
                <InputGroup
                  placeholder="year to start checking"
                  value={this.state.checkStartYear}
                  onChange={(e) => this.onCheckStartYearChanged(e.target.value)}
                />
                <ButtonGroup>
                  <Button intent="danger" onClick={this.checkDutyOffRequests}>
                    <TranslatedMessage id={TLCode.ROSTER_CheckDutyOffRequests} />
                  </Button>
                </ButtonGroup>
              </DivLine>
              <br />
              <DivLine>
                    <a
                      href={'https://www.afmps.be/sites/default/files/content/INSP/OFFICINES/Lst_Pharmacies_pub_Extended.xlsx'}
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                    >
                      &nbsp;<u>Pharmacies autorisées par l'AFMPS</u>&nbsp;
                    </a>
                <Button
                  intent="danger"
                  onClick={this.calculateAnnualReviews}
                  loading={annualReviewIssLoading}
                // disabled={secretariatId == null}
                >
                  <TranslatedMessage id={TLCode.ROSTER_CalculateAnnualReviews} />
                </Button>
                {/* <Button intent="danger" onClick={this.calculateNeighborhoods}>
                  <TranslatedMessage id={TLCode.ROSTER_CalculateNeighborhoods} />
                </Button> */}
                <InputGroup
                  placeholder="Google Maps max calls"
                  value={this.state.apbNumberToImport}
                  onChange={(e) => this.onGoogleMapsMaxCallsChange(e.target.value)}
                />
                <Button intent="success" onClick={this.saveGoogleMapsMaxCalls}>
                  {' '}
                  <TranslatedMessage id={TLCode.ROSTER_GoogleMapsMaxCalls} />
                </Button>

                <InputGroup
                  placeholder="Enter APB number"
                  value={this.state.apbNumberToImport}
                  onChange={(e) => this.onApbNumberChange(e.target.value)}
                />
                <Button intent="success" onClick={this.importPharmacy}>
                  {' '}
                  <TranslatedMessage id={TLCode.ROSTER_ImportPharmacy} />
                </Button>
              </DivLine>
              <br />
              <DivLine>
                DEV ONLY:{' '}
                <FileInput fill={true} onChange={this.handleFileTextChange} text={this.state.ruleFileName} />
              </DivLine>
            </Collapse>
          </Card>
        </Container>
        <PlannerFileLoadingModal
          fileIsLoading={fileIsLoading}
          modalOpened={modalFileLoadingOpened}
          onClosed={this.onImportModalClose}
          errors={dutiesImportError}
        />
      </MainSectionLayout>
    );
  }
}

export default withTranslate(PlannerPage);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const CardStyle = glamor.css({
  height: '100%',
  '& .ant-card-body': {
    height: '100%',
  },
});

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  .bp3-button {
    margin-right: 3px;
  }
`;

const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const labelStyle = css({
  fontWeight: 'bold',
  marginRight: '5px',
  marginTop: '5px',
});

const boxed = css({
  border: '1px solid green',
  height: '200px',
});
